/**
 * Group label for tokens that only resolve after an upstream task is completed.
 */
export const TASK_COMPLETION_GROUP = 'Task completion'

/**
 * Runtime workflow tokens available for {{variable}} substitution.
 * These are not extracted from HTTP responses — they are injected during execution.
 */
export const WORKFLOW_SYSTEM_VARIABLES = [
  {
    name: 'completed_by_name',
    description: 'Full name of the user who completed the upstream task',
    group: 'Task completion',
  },
  {
    name: 'completed_by_email',
    description: 'Email of the user who completed the upstream task',
    group: 'Task completion',
  },
  {
    name: 'completed_by_id',
    description: 'DME user ID of the user who completed the upstream task',
    group: 'Task completion',
  },
  {
    name: 'completed_task_name',
    description: 'Name of the task that was just completed',
    group: 'Task completion',
  },
  {
    name: 'completed_task_id',
    description: 'ID of the task that was just completed',
    group: 'Task completion',
  },
  {
    name: 'assigned_user_name',
    description: 'Name of the user a task step is assigned to (at task creation)',
    group: 'Task assignment',
  },
  {
    name: 'assigned_user_email',
    description: 'Email of the user a task step is assigned to (at task creation)',
    group: 'Task assignment',
  },
  {
    name: 'assigned_user_id',
    description: 'DME user ID the task step is assigned to (at task creation)',
    group: 'Task assignment',
  },
]

/**
 * Returns the system variables valid for a given node context.
 *
 * Task-completion tokens ({{completed_by_*}}, {{completed_task_*}}) only resolve
 * when an upstream task has been completed, so they are excluded unless
 * hasUpstreamCompletedTask is true. Assignment tokens are always available.
 *
 * @param {{ hasUpstreamCompletedTask?: boolean }} [context]
 */
export function getSystemVariablesForContext({ hasUpstreamCompletedTask = false } = {}) {
  return WORKFLOW_SYSTEM_VARIABLES.filter((variable) =>
    variable.group === TASK_COMPLETION_GROUP ? hasUpstreamCompletedTask : true
  )
}
